<template>
  <div
    class="responseMessage"
    :class="{'responseMessage-success': !responseMessage.IsError, 'responseMessage-error': responseMessage.IsError}"
  >
    <img v-if="!responseMessage.IsError" src="../assets/icons/response-success.png">
    <img v-else src="../assets/icons/response-error.png">
    
    <span>{{ responseMessage.Message }}</span>
    
    <img src="../assets/icons/close.png" alt="Close">
  </div>
</template>

<script>
export default {
  computed:{
      responseMessage(){
          return this.$store.getters.getResponseMessage;
      }
  }
};
</script>

<style scoped>
.responseMessage {
  padding: 10px 10px;
  position: fixed;
  left: 20px;
  bottom: -100px;
  background-color: white;
  z-index: 1000;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
  animation: messageFadeIn 10s;
}
.responseMessage span{
  display: inline-block;
  vertical-align: top;
  line-height: 25px;
  margin: 0 5px;
}
.responseMessage img{
  width: 25px;
}
.responseMessage img:nth-child(3){
  cursor: pointer;
  width: 20px;
}
.responseMessage-success{
  border-left: 2px solid #2ecc71;
}
.responseMessage-error{
  border-left: 2px solid #e74c3c;
}
@keyframes messageFadeIn {
  0% {
    bottom: -100px;
  }
  15% {
    bottom: 20px;
  }
  85% {
    bottom: 20px;
  }
  100% {
    bottom: -100px;
  }
}
</style>
